module.exports = __webpack_public_path__ + "img/marietta-norbi.e6812b39.jpg";